import { isNil } from 'ramda';
import { isFunction } from 'ramda-adjunct';
import { useCallback, useMemo, useState } from 'react';
import { keyProxy } from './localStorage';
export const createLocalStorageUseState = (key) => {
    const proxy = keyProxy(key);
    return (def) => {
        const [value, setValue] = useState(proxy.get() || def || null);
        const set = useCallback((valueOrUpdater) => setValue((old) => {
            const newValue = isFunction(valueOrUpdater) ? valueOrUpdater(old) : valueOrUpdater;
            if (old === newValue) {
                return old;
            }
            if (isNil(newValue)) {
                proxy.delete();
            }
            else {
                proxy.set(newValue);
            }
            return newValue;
        }), []);
        return useMemo(() => [value, set], [value, set]);
    };
};
//# sourceMappingURL=createLocalStorageUseState.js.map